import {
  OrdersCard,
  OrdersCardBody,
  OrdersCardBodyRow,
  OrdersCardHeader,
  OrdersCardHeaderChip,
  OrdersCardPriceText,
  OrdersListRowButton,
  OrdersListRowButtonContainer,
  UtensilBowlIcon,
} from 'src/pages/consumer/account/orders/styles';

import { formatCurrency } from 'common/FormatUtilities';
import { ChipColor } from 'src/shared/design-system/Chip';
import { VerticallyCenteredText } from 'src/shared/design-system/VerticallyCenteredText';
import { useHistory } from 'src/shared/hooks/useHistory';
import { Routes } from 'src/shared/Routes';
import styled from 'styled-components';
import { Colors } from 'web-common/src/shared/styles';
import { MealPlanData } from './MealPlansTab';

const EditButtonStyled = styled(OrdersListRowButton)`
  color: ${Colors.WHITE};
  border: 2px solid ${Colors.RASPBERRY};
`;

export const ConsumerMealPlanCard = ({ mealPlan }: { mealPlan: MealPlanData }) => {
  const history = useHistory();
  const { weeklyCost, unit, numServings } = mealPlan.mealPlanType;

  const header = (
    <OrdersCardHeader>
      <OrdersCardHeaderChip text={'Every week'} color={ChipColor.EGGPLANT} />
      <OrdersCardPriceText>
        <VerticallyCenteredText>Est. {formatCurrency(weeklyCost)}</VerticallyCenteredText>
      </OrdersCardPriceText>
    </OrdersCardHeader>
  );

  return (
    <OrdersCard header={header}>
      <OrdersCardBody>
        <OrdersCardBodyRow>
          <UtensilBowlIcon />
          <span>
            Weekly Shef Service: {unit} Dinners X {numServings} Serving
            {numServings > 1 ? 's' : ''}
          </span>
        </OrdersCardBodyRow>
      </OrdersCardBody>
      <OrdersListRowButtonContainer>
        <EditButtonStyled
          onClick={() => {
            history.push(Routes.CONSUMER_MEAL_PLANS_MANAGE);
          }}>
          Manage Service
        </EditButtonStyled>
      </OrdersListRowButtonContainer>
    </OrdersCard>
  );
};
